/* unplugin-vue-components disabled */import { render } from "./TextLogicalReasoningQuestionView.vue?vue&type=template&id=599499a0&scoped=true"
import script from "./TextLogicalReasoningQuestionView.vue?vue&type=script&lang=js"
export * from "./TextLogicalReasoningQuestionView.vue?vue&type=script&lang=js"

import "./TextLogicalReasoningQuestionView.vue?vue&type=style&index=0&id=599499a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599499a0"]])

export default __exports__